/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { organizationsCreate } from "../../funcs/organizationsCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .PostApiLeadScraperMicroserviceApiV1OrganizationRequestBody$inboundSchema,
};

export const tool$organizationsCreate: ToolDefinition<typeof args> = {
  name: "organizations_create",
  description: `Create a new organization

Creates a new organization within a tenant`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await organizationsCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
